import React from "react";
import MasterDetailLayout from "../../../../../components/layout/MasterDetailLayout";
import PrototypeCompactList from "../components/PrototypeCompactList";

const PrototypeSplitView = () => <MasterDetailLayout list={<PrototypeCompactList />} />;

export default PrototypeSplitView;
